import { CommentModel, ThreadModel } from '@anecdotes/commenting';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { UserClaims, AuthService } from '@anecdotes/auth-core';

import { Observable } from 'rxjs';
import { ThreadViewModel } from '../../models';
import { CommentingFacadeService, ConfirmationModalService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseThreadComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  protected currentUser: UserClaims;

  @Input()
  resource: ThreadViewModel;

  @Input()
  maxVisibleComments = 1;

  @Input()
  commentsLengthToBeCollapsed = 4;

  hiddenCommentsLength: number;
  thread$: Observable<ThreadModel>;
  collapsedComments: CommentModel[];
  private comments: CommentModel[];

  constructor(
    protected commentingFacadeService: CommentingFacadeService,
    protected authService: AuthService,
    protected confirmationService: ConfirmationModalService
  ) {}

  ngOnInit(): void {
    this.thread$ = this.commentingFacadeService.getThreadById(this.resource.threadId);
    this.commentingFacadeService
      .getCommentsByThreadId(this.resource.threadId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((comments) => {
        this.comments = comments;
        if (comments?.length > this.commentsLengthToBeCollapsed) {
          this.collapsedComments = this.comments.slice(-this.maxVisibleComments);
          this.hiddenCommentsLength = comments?.length - this.maxVisibleComments;
        } else {
          this.collapsedComments = comments;
        }
      });

    this.authService
      .getUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => (this.currentUser = user));
  }

  shouldMenuBeDisplayed(userId: string): boolean {
    return userId === this.currentUser.user_id;
  }

  showAllComments(): void {
    this.collapsedComments = this.comments;
    this.hiddenCommentsLength = null;
  }

  trackCommentByIds(index: number, comment: CommentModel): number | string {
    return comment ? comment.id : index;
  }

  buildTranslationKey(relativeKey: string): string {
    return `commenting.${relativeKey}`;
  }

  async deleteThread(): Promise<void> {
    const isThreadShouldBeRemoved = await this.confirmationService.openThreadDeleteConfirmation();
    if (isThreadShouldBeRemoved) {
      this.commentingFacadeService.deleteThread(this.resource.threadId);
    }
  }
}
